// 🔧 sponsors.js
// ✅ Purpose: Public-facing manager guide for sponsor setup in Let's Go Vote
// ✅ Features:
// - Explains sponsor levels, sponsor pages, and sponsor awards
// - Helps managers understand how sponsors appear publicly
// - Public and SEO-friendly
// - Uses the Dashboard-style LGV layout
// - Fully block-commented for clarity and future devs

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../../components/seo_head";

function SponsorsGuide() {
  return (
    <section id="top-content" className="container-fluid py-5">
      <SeoHead
        title="Sponsors Guide | Let's Go Vote"
        description="Learn how to manage sponsor levels, sponsor pages, sponsor logos, and sponsor awards with Let's Go Vote."
        path="/guides/sponsors"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Guides", path: "/guides" },
          {
            name: "Sponsors",
            path: "/guides/sponsors",
          },
        ]}
      />
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5">⭐ Sponsors</h1>
          <p className="lead text-muted">
            Give sponsors visibility before, during, and after your event.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white">
        <section className="mb-5">
          <div className="alert alert-info text-start">
            <h5 className="mb-3">Sponsors should feel part of the event</h5>
            <p className="mb-0">
              Let&apos;s Go Vote helps managers display sponsor logos, organize
              sponsor levels, create sponsor pages, and recognize sponsor award
              winners.
            </p>
          </div>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 1: Create sponsor levels</h3>
          <p>
            Sponsor levels help group sponsors by contribution level or event
            role. Common examples include Title Sponsor, Gold Sponsor, Silver
            Sponsor, Bronze Sponsor, or Community Sponsor.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 2: Add sponsor profiles</h3>
          <p>
            Sponsor profiles can include names, logos, descriptions, website
            links, and contact details. These profiles help attendees learn more
            about the businesses and organizations supporting your event.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 3: Display sponsors publicly</h3>
          <p>
            Sponsors can appear on the event home page and the public sponsors
            page. Grouping sponsors by level helps higher-level sponsors receive
            stronger visibility while keeping the page organized.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 4: Add sponsor awards</h3>
          <p>
            Sponsor awards allow a sponsor to recognize a specific entry, such
            as Sponsor&apos;s Choice, Best Display, Best Paint, or a custom award
            title. Award winners can be shown publicly after the event.
          </p>
        </section>

        <section className="mb-0">
          <div className="alert alert-primary text-start mb-0">
            <h5 className="mb-3">Related guide</h5>
            <p className="mb-3">
              Sponsors often connect closely with public event promotion and
              event-day visibility.
            </p>

            <Link to="/guides/running-event-day" className="btn btn-primary">
              Review Running Event Day
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}

export default SponsorsGuide;